import { useDrag, useDrop, XYCoord } from 'react-dnd';
import { useRef } from 'react';
import { IKanbanCard } from '../../types/layout/kanban';
import { KanbanColumnItems } from './column';
import { useKanbanCard } from '../../hooks/kanban/useKanbanCard';

interface IKanbanCardProps extends IKanbanCard {
    onEditClick?: (cardId: string) => void;
}

function setPriorityClass(priority: string) {
    switch (priority) {
        case 'Критический':
            return 'm-critical';
        case 'Важный':
            return 'm-high';
        case 'Средний':
            return 'm-middle';
        default:
            return '';
    }
}

function KanbanCard({
    name, project, deadLine, priority, usersCustomer, usersExecutor, id, number, unreadMessagesCount, onEditClick,
}: IKanbanCardProps) {
    const ref = useRef<HTMLDivElement>(null);
    const {
        dragging, moveCard, setDragging,
    } = useKanbanCard(id);

    const [, drag] = useDrag(() => ({
        item: { id },
        type: KanbanColumnItems.card,
        collect: (monitor) => {
            if (monitor.isDragging()) {
                setDragging(true);
            }
            if (monitor.didDrop()) {
                setDragging(false);
            }
        },
    }));

    const [{ handlerId }, drop] = useDrop<{ id: string }, void, {handlerId: any}>(() => ({
        accept: KanbanColumnItems.card,
        collect: (monitor) => ({
            handlerId: monitor.getHandlerId(),
        }),
        hover: (item, monitor) => {
            if (!ref.current) {
                return;
            }

            if (item.id === id) {
                return;
            }

            // const dragIndex = cards.findIndex((el) => el.id === item.id);
            // const hoverIndex = cards.findIndex((el) => el.id === id);
            const hoverBoundingRect = ref.current?.getBoundingClientRect();
            const hoverMiddleY = (hoverBoundingRect.bottom - hoverBoundingRect.top) / 2;
            const clientOffset = monitor.getClientOffset();
            const hoverClientY = (clientOffset as XYCoord).y - hoverBoundingRect.top;

            moveCard(item.id, id, hoverClientY > hoverMiddleY);
        },
    }));

    drag(drop(ref));

    return (
        <div className="card card-outline" ref={ref} style={{ opacity: dragging ? 0.3 : 1 }} data-handler-id={handlerId}>
            <div className="card-header">
                <div className="card-number">
                    #
                    {number}
                </div>
                <div className="card-title" dangerouslySetInnerHTML={{ __html: project }} />
                <div className="card-tools-section">
                    {unreadMessagesCount > 0 && (
                        <span className="card-tools-counter">{unreadMessagesCount}</span>
                    )}
                    {setPriorityClass(priority) !== '' && (
                        <span className={`card-tools-priority ${setPriorityClass(priority)}`} />
                    )}
                    {typeof onEditClick === 'function' && (
                        <div className="card-tools">
                            <button className="btn btn-tool card-edit-button" type="button" aria-label="Edit" onClick={() => onEditClick(id)} />
                        </div>
                    )}
                </div>
            </div>
            <div className="card-body">
                {/* <div dangerouslySetInnerHTML={{ __html: body }} /> */}
                <div className="card-name" dangerouslySetInnerHTML={{ __html: name }} />
                <div className="card-data">
                    <span className="card-data-name">Выполнить до</span>
                    <span className="card-data-value">{deadLine || '—'}</span>
                </div>
                <div className="card-data">
                    <span className="card-data-name">Клиент</span>
                    <span className="card-data-value">—</span>
                </div>
                <div className="card-data">
                    <span className="card-data-name">Заказчик</span>
                    <span className="card-data-value">{usersCustomer || '—'}</span>
                </div>
                <div className="card-data">
                    <span className="card-data-name">Исполнитель</span>
                    <span className="card-data-value">{usersExecutor || '—'}</span>
                </div>

            </div>
        </div>
    );
}

KanbanCard.defaultProps = {
    onEditClick(id: string) {
        console.log(id);
    },
};

export default KanbanCard;
